<div [formGroup]="group" class='dynamic-radio'>
  <!-- <mat-form-field class="basic-radio" [ngClass]="config.class" *ngIf="!config.hide"> -->

  <mat-label class="radio-label">{{config.label}}</mat-label>
  <mat-radio-group [formControlName]="config.name"  [attr.name]="config.name">
    @for (option of config.options; track option) {
      <mat-radio-button class="radio-button" [value]='option.id' id="radiobtn{{option.id}}" [checked]="config.value.id == option.id">
        {{option.value}}
      </mat-radio-button>
    }
  </mat-radio-group>
  <!-- <mat-error *ngIf="group.controls[FormControlName].hasError('required') && config.showErrorText">
  Field Required
</mat-error> -->
<!-- </mat-form-field> -->
</div>
